import { useMemo } from 'react';
import { DefaultCalibrationLevelDataPoint } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionChartType';
import { getCalibrationScore } from 'libs/end-to-end/src/tests-utils';
import { PayCorrectionOutput } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionOutput';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';

export const usePayCorrectionChartData = ({
  payCorrectionOutput,
  calibrationFraming,
}: {
  payCorrectionOutput: PayCorrectionOutput | null;
  calibrationFraming: CalibrationFraming;
}) => {
  return useMemo(() => {
    const key = 'overall';
    const top10 =
      payCorrectionOutput?.level_pay_correction_results
        .sort(
          (a, b) =>
            getCalibrationScore({
              testCount: a.pay_correction_summary[key].test_count,
            }) -
            getCalibrationScore({
              testCount: b.pay_correction_summary[key].test_count,
            }),
        )
        .slice(0, 10) || [];

    return (
      top10.map((result) => {
        const currentLevel = result.pay_correction_summary[key];
        const dataPoint: DefaultCalibrationLevelDataPoint = {
          id: result.level_name,
          calibrationScore: getCalibrationScore({
            testCount: currentLevel.test_count,
          }),
          [result.level_name]: getCalibrationScore({
            testCount: currentLevel.test_count,
          }),
          avgUnderpaid: currentLevel.avg_pay_gap,
          needsAttention: currentLevel.num_underpaid,
          budgetNeeded: currentLevel.budget_needed,
          disparity: currentLevel.avg_pct_pay_gap * 100,
        };
        return dataPoint;
      }) || []
    );
  }, [payCorrectionOutput]);
};
